<template>
    <div class="d-flex align-items-center">
        <!-- Shopping cart icon with number of items badge -->
        <router-link to="/cart" class="nav-link">
            <div class="cart-container d-flex flex-row align-items-center">
                <div class="cart-left">
                    <p class="cart-text">Cart</p>
                </div>
                <div class="cart-right">
                    <p class="cart-text">
                        {{numberOfCartItems}}
                    </p>
                </div>
            </div> 
        </router-link>
    </div>
</template>

<script>
    export default {
        computed: {
            numberOfCartItems() {
                return Object.keys(this.$store.state.cart).length;
            }
        }
    }
</script>